import React from 'react';
import { useTranslation } from 'react-i18next';

interface TableHeaderProps {
    data: any[];
    handleSort: (key: string) => void;
    sortBy: string;
    sortOrder: string;
    showActiveColumns?: boolean;
}



const TableHeader: React.FC<TableHeaderProps> = ({ data, handleSort, sortBy, sortOrder, showActiveColumns }) => {
    const { t } = useTranslation();

    // Translate a column key, falling back to a capitalized version of the raw key.
    const label = (key: string) =>
        t(`tableHeaders.${key}`, { defaultValue: key.charAt(0).toUpperCase() + key.slice(1) });

    return (
        <thead className="bg-brand-50 text-brand-800 text-left">
            <tr>
                {data.length > 0 &&
                    Object.keys(data[0])
                        .filter((key) => !['_id', 'category', '__v', 'active'].includes(key)) // Exclude unwanted keys and 'active' (we'll show subfields)
                        .map((key) => (
                            <th
                                key={key}
                                className="px-4 py-2 cursor-pointer"
                                onClick={() => handleSort(key)}
                            >
                                <div className="flex items-center justify-between">
                                    {label(key)}
                                    {sortBy === key && sortOrder === "asc" ? (
                                        <span>&#8593;</span>
                                    ) : sortBy === key && sortOrder === "desc" ? (
                                        <span>&#8595;</span>
                                    ) : null}
                                </div>
                            </th>
                        ))}


                                {/* Add Active EN/MK/SQ columns only if showActiveColumns is true */}
                                {showActiveColumns && (
                                    <>
                                        <th className="px-4 py-2">{label('active')} EN</th>
                                        <th className="px-4 py-2">{label('active')} MK</th>
                                        <th className="px-4 py-2">{label('active')} SQ</th>
                                    </>
                                )}

                <th className="px-4 py-2">{label('action')}</th> {/* Action header */}

            </tr>
        </thead>
    );
};

export default TableHeader;
